import { LoadingStatuses } from '@packages/shared/core/common/entities';

export type SupportState = {
  submitStatus: LoadingStatuses;
  error: string | null;
};

export const supportInitialState: SupportState = {
  submitStatus: LoadingStatuses.IDLE,
  error: null,
};
